import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const MASK_REVEAL_VISIBILITY = 0.5;

$(document).ready(function () {
    const media = gsap.matchMedia();

    media.add(
        "(min-width: 992px) and (prefers-reduced-motion: no-preference)",
        function () {
            $(".parallax").each(function () {
                const section = this;
                const wrapper = $(section).children(".wrapper").first();

                if (wrapper.length === 0) {
                    return;
                }

                ScrollTrigger.create({
                    trigger: section,
                    start: function () {
                        return `top top+=${$.constants.menuHeight}`;
                    },
                    end: "bottom top",
                    pin: wrapper.get(0),
                    pinSpacing: false,
                    anticipatePin: 1,
                    invalidateOnRefresh: true,
                    refreshPriority: $.refreshPriority(section),
                });
            });
        }
    );

    media.add("(prefers-reduced-motion: no-preference)", function () {
        const masked = $(".masked");

        masked.each(function () {
            const section = this;

            const reveal = function (self) {
                $(section).toggleClass("unmasked", self.scroll() >= self.start);
            };

            ScrollTrigger.create({
                trigger: section,
                start: function () {
                    return `${MASK_REVEAL_VISIBILITY * 100}% bottom`;
                },
                end: "bottom top",
                invalidateOnRefresh: true,
                refreshPriority: $.refreshPriority(section),
                onEnter: reveal,
                onLeaveBack: reveal,
                onRefresh: reveal,
            });
        });

        return function () {
            masked.removeClass("unmasked");
        };
    });

    media.add("(prefers-reduced-motion: reduce)", function () {
        const masked = $(".masked").addClass("unmasked");

        return function () {
            masked.removeClass("unmasked");
        };
    });
});
